import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';
import { TipoFila } from '../models/enum';
import { FilaFuncionario } from '../models/filas/fila-funcionario';

@Injectable({
  providedIn: 'root'
})
export class FilaFuncionarioService {

  constructor(private http: HttpClient) { }

  consultarPorId(idFuncionario: number, idFila: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FilaFuncionario/BuscarFuncionario',
      { params: new HttpParams().set('idFuncionario', idFuncionario.toString()).set('idFila', idFila.toString()) });
  }

  consultarLista(idFila, somenteDisponiveis) {
    let parametros = new HttpParams();

    if (idFila !== null && idFila !== undefined) {
      parametros = parametros.set('idFila', idFila);
    }

    if (somenteDisponiveis !== null && somenteDisponiveis !== undefined) {
      parametros = parametros.set('somenteDisponiveis', somenteDisponiveis);
    }

    return this.http.get<any>(globals.apiUrl + '/api/FilaFuncionario/ListarFuncionarios',
      {
        params: parametros
      });
  }

  salvar(filaFuncionario: FilaFuncionario) {
    return this.http.post(globals.apiUrl + '/api/FilaFuncionario/SalvarFuncionario', filaFuncionario);
  }

  remover(idFuncionario: number, idFila: number) {
    return this.http.post(globals.apiUrl + '/api/FilaFuncionario/RemoverFuncionario', {},
      { params: new HttpParams().set('idFuncionario', idFuncionario.toString()).set('idFila', idFila.toString()) }
    );
  }

}
